module.exports = __webpack_public_path__ + "138e596594e4a77e90ec379aa2d7243e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-28.png
// module id = 2122
// module chunks = 0